import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link } from "react-router-dom";
import constants from "../constants/constants";
import logo1 from "../assets/images/2020_MLS_FINAL_WHITE.png";
import logo2 from "../assets/images/Realtor-logo-270x300.png";
import { motion, AnimatePresence } from "framer-motion";
import footerBg from "../assets/images/shutterstock_2734635953.jpg"

export default function Footer() {
  const [menus, setMenus] = useState({
    buying: false,
    selling: false,
    info: false,
  });
  function setDropdown(key) {
    var temp = { ...menus };
    for (let k of Object.keys(temp)) {
      if (key === k) {
        temp[k] = !temp[k];
      } else {
        temp[k] = false;
      }
    }

    setMenus(temp);
  }
  return (
    <footer
      className="relative overflow-hidden bg-cover bg-center text-white"
      style={{
        backgroundImage: `url(${footerBg})`
      }}
    >
      <div className="absolute inset-0 bg-black/60" />
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: .4 }}
        className="relative z-10 w-full py-12 px-10 md:px-16 flex flex-wrap lg:flex-nowrap gap-x-20 gap-y-10 justify-between"
      >
        <div className="grid md:grid-cols-2 gap-x-24 w-fit gap-y-3 child:relative mt-2">
          <div className="flex flex-col gap-y-6 mb-5"
          >
            <Link
              to="/"
              className="group relative w-fit transition-colors duration-300 font-semibold"
            >
              Home
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-white/50 transition-all duration-300 group-hover:w-full" />
            </Link>
            <Link
              to="/about"
              className="group relative w-fit transition-colors duration-300 font-semibold"
            >
              About
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-white/50 transition-all duration-300 group-hover:w-full" />
            </Link>
            <Link
              to="/contact"
              className="group relative w-fit transition-colors duration-300 font-semibold"
            >
              Contact
              <span className="absolute left-0 -bottom-1 h-[2px] w-0 bg-white/50 transition-all duration-300 group-hover:w-full" />
            </Link>
          </div>
          <div className="flex w-full flex-col gap-y-4">
            {/* Buying */}
            <div className="pb-2">
              <button
                type="button"
                onClick={() => setDropdown("buying")}
                className="flex w-full items-center text-left font-semibold"
              >
                <span>Buying</span>

                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={`transition-transform duration-300 ml-5 text-white/50 text-xl ${menus.buying ? "rotate-180" : ""
                    }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${menus.buying ? "max-h-40 opacity-100 mt-3" : "max-h-0 opacity-0"
                  }`}
              >
                <div className="flex flex-col gap-3 pl-5">
                  <Link
                    to="/calculator"
                    className="text-white/80 hover:text-white"
                  >
                    Mortgage Calculator
                  </Link>

                  <Link
                    to="/listings"
                    className="text-white/80 hover:text-white"
                  >
                    Listings
                  </Link>
                </div>
              </div>
            </div>

            {/* Selling */}
            <div className="pb-2">
              <button
                type="button"
                onClick={() => setDropdown("selling")}
                className="flex w-full items-center text-left font-semibold"
              >
                <span>Selling</span>

                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={`transition-transform duration-300 ml-5 text-white/50 text-xl ${menus.selling ? "rotate-180" : ""
                    }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${menus.selling ? "max-h-32 opacity-100 mt-3" : "max-h-0 opacity-0"
                  }`}
              >
                <div className="flex flex-col gap-3 pl-5">
                  <Link
                    to="/evaluation"
                    className="text-white/80 hover:text-white"
                  >
                    Free Home Evaluation
                  </Link>
                </div>
              </div>
            </div>

            {/* Information */}
            <div className="pb-2">
              <button
                type="button"
                onClick={() => setDropdown("info")}
                className="flex w-full items-center text-left font-semibold transition-colors"
              >
                <span>Information</span>

                <FontAwesomeIcon
                  icon={faAngleDown}
                  className={`transition-transform duration-300 ml-5 text-white/50 text-xl ${menus.info ? "rotate-180" : ""
                    }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${menus.info ? "max-h-32 opacity-100 mt-3" : "max-h-0 opacity-0"
                  }`}
              >
                <div className="flex flex-col gap-3 pl-5">
                  <Link
                    to="/real-estate-reports"
                    className="text-white/80 hover:text-white"
                  >
                    Real Estate Reports
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end">
          <h1 className="text-2xl pb-4 self-start text-white">
            FOLLOW
          </h1>
          <div className="flex flex-wrap gap-x-5 gap-y-5">
            {Object.entries(constants.SOCIALS)?.map(([k, v]) => (
              <motion.a
                href={constants.SOCIALS[k]}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  scale: 1.2,
                  rotate: 10,
                  color: "#fff"
                }}
                whileTap={{ scale: .9 }}
                className="h-12 w-12 rounded-full bg-white/10 flex items-center justify-center transition-colors text-white hover:bg-white/20 mb-2"
              >
                <FontAwesomeIcon
                  className="fa-xl"
                  icon={constants.ICONS[k]}
                />
              </motion.a>
            ))}
          </div>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: .4 }}
        className="relative z-10 border-t border-white/20 py-10 px-10 md:px-16 text-white/80"
      >
        {constants.SHOW_FOOTER_DISCLAIMER && (
          <>
            <div className="mb-3">
              <div className="p-2 w-fit inline-flex self-center rounded-lg mr-3">
                <img src={logo2} className="w-8"></img>
              </div>
              <span>
                The trademarks REALTOR®, REALTORS®, and the REALTOR® logo are
                controlled by The Canadian Real Estate Association (CREA) and
                identify real estate professionals who are members of CREA.
              </span>
            </div>
            <div className="mb-3">
              <div className="p-2 w-fit inline-flex self-center rounded-lg mr-3">
                <img src={logo1} className="w-12"></img>
              </div>
              <span>
                The trademarks MLS®, Multiple Listing Service® and the associated
                logos are owned by The Canadian Real Estate Association (CREA) and
                identify the quality of services provided by real estate
                professionals who are members of CREA.
              </span>
            </div>
          </>
        )}
        <p className="flex items-center">
          © Presented by{' '}
          <a
            href={constants.FOOTER_LOGO_URL}
            rel="nofollow noopener noreferrer"
            target="_blank"
            className="flex items-center ml-2"
          >
            <img src={constants.FOOTER_LOGO} alt="Footer Logo" className="max-w-24 inline h-7" />
            {constants.FOOTER_NAME}
          </a>
        </p>
      </motion.div>
    </footer >
  );
}
